const borderRadius = {
  borderRadius2: 2,
  borderRadius4: 4,
  borderRadius8: 8,
  borderRadius16: 16,
  borderRadius24: 24,
};

export default borderRadius;
